import { _decorator } from 'cc';
import GraphicsPainter, { GraphicsCommand } from '../Graphics/GraphicsPainter';
import MultiThemeComponent from './MultiThemeComponent';

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('GraphicsCommandContainer')
class GraphicsCommandContainer {
    @property([GraphicsCommand])
    public readonly commands: GraphicsCommand[] = [];
}

@ccclass('MultiThemeGraphicsPainter')
@menu('MultiTheme/MultiThemeGraphicsPainter')
@requireComponent(GraphicsPainter)
export default class MultiThemeGraphicsPainter extends MultiThemeComponent<GraphicsPainter> {
    @property([GraphicsCommandContainer])
    private readonly commandContainers: GraphicsCommandContainer[] = [];

    public getMaxTheme(): number {
        return this.commandContainers.length;
    }

    public updateGraphicsCommandContainers(containers: GraphicsCommandContainer[]) {
        this.commandContainers.length = 0;
        this.commandContainers.push(...containers);
        this.onThemeChanged();
    }

    protected getTarget() {
        return this.getComponent(GraphicsPainter);
    }

    protected onThemeChanged() {
        this.target.commands = this.commandContainers[this._theme].commands;
    }
}
